module.exports = __webpack_public_path__ + "img/cabinet_213.fdb455d0.jpg";